import ParagraphSkeleton from './ParagraphSkeleton';

function ImageArticleCardSkeleton() {
  return (
    <div className='flex flex-col w-full p-0 bg-white rounded-md drop-shadow-2xl shadow mr-10'>
      <div className='w-full h-[250px] rounded-t-md bg-gray-300' />
      <div className='p-4 flex flex-col'>
        <div className='flex flex-row w-full items-left'>
          <div className='mb-8 mt-4 w-24 h-8 rounded-md bg-gray-300' />
        </div>

        <ParagraphSkeleton />

        <div className='flex flex-row w-full items-left'>
          <div className='mb-8 mt-4 w-48 h-4 rounded-md bg-gray-300' />
        </div>

        <div className='flex flex-row w-full items-left'>
          <div className='mb-8 mt-4 w-full h-[40px] rounded-md bg-gray-300' />
        </div>
      </div>
    </div>
  );
}

export default ImageArticleCardSkeleton;
